<script>
import moment from "moment-timezone"

export default {
  name: "DateTime",
  methods: {
    dateFormat(time, format = "MMM Do YYYY [at] h:mm A") {
      time = moment.tz(time, "UTC")
      if (this.$auth.check())
        return time.tz(this.$auth.user().timezone).format(format)
      else return time.tz("America/New_York").format(format) + " EST"
    },
    nowInTimezone(timezone) {
      return moment.tz(timezone).format("MMM Do YYYY [at] h:mm A")
    },
    fromNow(time) {
      return moment.tz(time, "UTC").fromNow()
    },
    latest(first, second) {
      let f = moment(first),
        s = moment(second);
      return f.diff(s) >= 0 ? first : second
    }
  }
}
</script>
